import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconPaused: React.FC<IconType> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  iconClassName,
}) => {

  const defaultMeasurements: Measurements = {
    height: 15,
    width: 12,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-paused">
      <svg
        className="fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 12 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 14C0 14.5523 0.447715 15 1 15H3C3.55228 15 4 14.5523 4 14V1C4 0.447715 3.55228 0 3 0H1C0.447715 0 0 0.447715 0 1V14ZM9 0C8.44771 0 8 0.447715 8 1V14C8 14.5523 8.44771 15 9 15H11C11.5523 15 12 14.5523 12 14V1C12 0.447715 11.5523 0 11 0H9Z" />
      </svg>
    </Icon>
  );
};

export default IconPaused;
